/// Displays estimated label dimensions aka aspect ratio.

import { bindSliderChanges } from "./bindings/sliders";
import { bindLabelPreviewChanges } from "./bindings/label_preview";
import { updateDisplayedDimensions } from "./display";
import { idleCallback } from "~/label/util";

/* Initializer to call on load, such as from recipes_show.js onViewLoad */
export const bindDimensions = () => {
  // Update the dimensions when:
  // - when the label preview itself changes (i.e. anything within #label-and-claim-div)
  // - when the recipe title changes or gets toggled
  // - when the sliders change (which might not be strictly necessary)
  idleCallback(() => {
    updateDisplayedDimensions(); // Call once to initialize.
    bindLabelPreviewChanges();
    bindSliderChanges();
  });
};
